import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import App from "./App";
import "./index.css";
import store from "./store";
import DrawerProvider from "./utilities/context/DrawerProvider";
import AppThemeProvider from "./utilities/Theme/Theme";
render(
  <React.StrictMode>
    <AppThemeProvider>
      <Provider store={store}>
        <DrawerProvider>
          <App />
        </DrawerProvider>
      </Provider>
    </AppThemeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(//console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
